// extracted by mini-css-extract-plugin
export default {"family":"family__family___[chunkhash-base64-5]","married":"family__married___[chunkhash-base64-5]"};